import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { Col, Row, Card, CardBody } from "reactstrap";
import { RTLProps } from "../../shared/prop-types/ReducerProps";
import BillingInfo from "./componets/BillingInfo";
import RigthInfo from "./componets/RigthInfo";
import BigCalendar from "../DefaultPages/Calendar/components/BigCalendar";
import EventLabels from "../DefaultPages/Calendar/components/EventLabels";
import Spinner from "react-bootstrap/Spinner";
import Welcome from "../DisplayDashboardToUsers/Welcome";
import TranscriptionProfile from "../DisplayDashboardToUsers/TranscriptionProfile";
import DoctorProfile from "../DisplayDashboardToUsers/DoctorProfile";
import PatientSurveyProfile from "../DisplayDashboardToUsers/PatientSurveyProfile";
import urlImageDashboard from "../../assets/img/img_dashboard3.jpeg";
import { Container } from "@material-ui/core";

const AppDashboard = ({ rtl }) => {
  const { t } = useTranslation("common");

  const user = JSON.parse(sessionStorage.getItem("usuario"));
  const [dataEvents, setDataEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userPermits, setUserPermits] = useState([]);

  const fecha = new Date();

  const validatePermissions = () => {
    var user = JSON.parse(sessionStorage.getItem("usuario"));
    if (user != null) {
      if (user.perfil != undefined) {
        var perfil = user.perfil?.modulos;
        setUserPermits(perfil);
      } else {
        var perfil = [];
        setUserPermits(perfil);
      }
    } else {
      setUserPermits([]);
    }
  };

  const getCalendarData = async () => {
    setLoading(true);

    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        "calendario/listar?id_usuario=" +
        user.id_usuario +
        "&month=" +
        (fecha.getMonth() + 1) +
        "&year=" +
        fecha.getFullYear(),
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      },
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        //console.log(data);
        filterData(data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const filterData = (data) => {
    let newData = [];

    for (let i = 0; i < data.length; i++) {
      newData[i] = {
        id: data[i].id_calendario,
        title: data[i].titulo,
        start: new Date(data[i].fecha_inicio),
        end: new Date(data[i].fecha_final),
        priority:
          data[i].prioridad === 1
            ? "non"
            : data[i].prioridad === 2
              ? "family"
              : "high",
      };
    }

    setDataEvents(newData);
    setLoading(false);
  };

  useEffect(() => {
    validatePermissions();
    getCalendarData();
  }, []);

  return (
    <Container /* className="dashboard" */>
      {userPermits && userPermits.includes(46) ? (
        <Fragment>
          <Row>
            {loading ? (
              <Spinner animation="border" variant="success" />
            ) : (
              <div className="bg-full-dashboard">
                <img
                  src={urlImageDashboard}
                  alt="Dashboard Logo"
                />
              </div>
            )}
          </Row>
        </Fragment>
      ) : userPermits.includes(44) ||
        userPermits.includes(41) ||
        userPermits.includes(42) ? (
        <Fragment>
          <Row>
            <Welcome user={user} />
            <RigthInfo />
          </Row>
        </Fragment>
      ) : userPermits.includes(30) ? (
        <Fragment>
          <Row>
            <Welcome user={user} />
            <TranscriptionProfile user={user} />
          </Row>
        </Fragment>
      ) : userPermits.includes(32) ? (
        <Fragment>
          <Row>
            <Welcome user={user} />
            <DoctorProfile user={user} />
          </Row>
        </Fragment>
      ) : userPermits.includes(51) ? (
        <Fragment>
          <Row>
            <Welcome user={user} />
            <PatientSurveyProfile />
          </Row>
        </Fragment>
      ) : (
        <Fragment>
          <Row>
            <Welcome user={user} />
          </Row>
        </Fragment>
      )}
    </Container>
  );
};

AppDashboard.propTypes = {
  rtl: RTLProps.isRequired,
};

export default connect((state) => ({
  rtl: state.rtl,
}))(AppDashboard);
